import { render } from "./SuggestedFollowOnQuestions.vue?vue&type=template&id=2fd9fa54&scoped=true&ts=true"
import script from "./SuggestedFollowOnQuestions.vue?vue&type=script&lang=ts"
export * from "./SuggestedFollowOnQuestions.vue?vue&type=script&lang=ts"

import "./SuggestedFollowOnQuestions.vue?vue&type=style&index=0&id=2fd9fa54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd9fa54"]])

export default __exports__